import type { ReactNode } from "react";
import { LineScopeContext, useLineScope } from "./lineScopeContext";
import { FIELD_PLACEHOLDER_CHIP_CLASS } from "./quoteFields";

interface FpBreaksProps {
  /** Stamps the template body once, keyed by the given stamp key, or null when the template child is missing. */
  stampTemplate: ((stampKey: string) => ReactNode[]) | null;
}

/**
 * Renders `<fp-breaks>`: stamps its template body once per quantity break of
 * the enclosing item line.
 * @param props - The template stamp
 * @returns The stamped break instances, or null outside an item-line template
 */
export function FpBreaks({ stampTemplate }: FpBreaksProps) {
  const scope = useLineScope();
  if (!stampTemplate) {
    return (
      <span className={`${FIELD_PLACEHOLDER_CHIP_CLASS} font-mono`}>
        {"⟨fp-breaks: missing template⟩"}
      </span>
    );
  }
  if (!scope || scope.line.type !== "ITEM") {
    return null;
  }
  return (
    <>
      {scope.line.quantityBreaks.map((quantityBreak, index) => (
        <LineScopeContext.Provider
          key={index}
          value={{ ...scope, quantityBreak }}
        >
          {stampTemplate(`qb-${index}`)}
        </LineScopeContext.Provider>
      ))}
    </>
  );
}
